'use client';

import React, { useState, useEffect, ReactNode } from 'react';
import { useThrottledFn, useWindowScroll } from 'beautiful-react-hooks';
import { Container } from '../../../../components/Container';
import { executionEnvironment } from '../../../../wag-react/common/xenv';
import { Portal } from '../../../../wag-react/components/Portal';
import { Box } from '../../../../wag-react/next-components/box';
import { Button } from '../../../../wag-react/next-components/button';
type Props = {
  children: ReactNode;
  onClick: () => void;
};
const SHOW_FAB_SCROLL_Y_THRESHOLD = 494;
export const BookWalkerFab = ({
  children,
  onClick
}: Props) => {
  const initialScrollY = executionEnvironment.isSSR ? 0 : window.scrollY;
  const [scrollY, setScrollY] = useState(initialScrollY);
  const isVisible = scrollY > SHOW_FAB_SCROLL_Y_THRESHOLD;
  const onWindowResizeHandler = useThrottledFn(() => {
    const nextScrollY = executionEnvironment.isSSR ? 0 : window.scrollY;
    setScrollY(nextScrollY);
  }, 200);
  useWindowScroll(onWindowResizeHandler as unknown as () => undefined);
  useEffect(() => () => onWindowResizeHandler.cancel());
  return isVisible && <Portal>
        <Box bg="white" bottom={0} pb="16px" pt="24px" display={['block', 'block', 'none']} position="fixed" width={1} zIndex={1000}>
          <Container>
            <Button variant="contained" width={1} onClick={onClick}>
              {children}
            </Button>
          </Container>
        </Box>
      </Portal>;
};